import { api, errMsg } from "./api";

const SRC = "https://checkout.razorpay.com/v1/checkout.js";

const loadScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = SRC;
    s.onload = () => resolve(!!window.Razorpay);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export async function buyCredits(selection, { onSuccess, onError, onDismiss }, ops = { create: api.creditsCreateOrder, verify: api.creditsVerify }) {
  try {
    if (!(await loadScript())) throw new Error("Could not load the payment window. Check your connection.");
    const order = await ops.create(selection);
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      name: "Ishukart",
      description: `${order.pack.credits} build credits`,
      order_id: order.order_id,
      prefill: { name: order.name || "", email: order.email || "", contact: order.phone || "" },
      theme: { color: "#0F172A" },
      handler: async (resp) => {
        try {
          onSuccess?.(await ops.verify(resp));
        } catch (e) {
          onError?.(errMsg(e, "Payment verification failed"));
        }
      },
      modal: { ondismiss: () => onDismiss?.() },
    });
    rzp.on("payment.failed", (r) => onError?.(r?.error?.description || "Payment failed"));
    rzp.open();
  } catch (e) {
    onError?.(errMsg(e, "Could not start payment"));
  }
}
